enum DispatcherEvent {
  AddFavorite = 'add_favorite',
  AddSavedSearch = 'add_saved_search',
  ContinuePurchase = 'continue_purchase',
  EnterFullscreen = 'enter_fullscreen',
  FavoriteAdded = 'favorite_added',
  FavoriteRemoved = 'favorite_removed',
  LeaveFullscreen = 'leave_fullscreen',
  Link = 'link',
  LogIn = 'log_in',
  OpenModal = 'open_modal',
  PageReady = 'page_ready',
  Share = 'share',
  StartPreOrder = 'start_preorder',
  StartPurchase = 'start_purchase',
  ToggleTradeIn = 'toggle_trade_in'
}

export default DispatcherEvent;
